import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankService } from '@services/banks.service';
import Swal from 'sweetalert2'
import { CoreModule } from 'app/modules/core.module';

@Component({
  selector: 'app-modal-bank',
  standalone: true,
  imports: [CoreModule],
  templateUrl: './modal-bank.component.html',
  styleUrls: ['./modal-bank.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalBankComponent implements OnInit {
  @Input() bank: any
  @Input() permissions: any
  @Output() bank_save: EventEmitter<Boolean> = new EventEmitter<Boolean>()
  public name = ""
  public code: any
  public BankForm: FormGroup
  private newBank = true
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })

  private destroyRef = inject(DestroyRef)

  constructor(
    private fb: FormBuilder,
    private _bankService: BankService,
    private modalService: NgbModal,
  ) {
    this.BankForm = this.fb.group({
      _id: [null],
      name: [null, [Validators.required, Validators.minLength(5)]],
      code: [null, [Validators.required, Validators.pattern('^[0-9,$]*$')]],
      enabled: [true, [Validators.required]]
    })
  }

  ngOnInit(): void {
    if (this.bank != null) {
      this.newBank = false
      this.BankForm.patchValue({
        _id: this.bank._id,
        name: this.bank.name,
        code: this.bank.code,
        enabled: this.bank.enabled
      })
    }
  }

  submit() {
    if (this.BankForm.valid) {
      this.newBank == true ? this._bankService.save(this.BankForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.cerrarModal(res) }) : this._bankService.update(this.BankForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.cerrarModal(res); this.newBank = true })
      this.Toast.fire({
        text: 'Banco actualizado',
        icon: 'success'
      })
    }
  }

  cerrarModal(res: any) {
    if (res) this.bank_save.emit(true)
    this.modalService.dismissAll()
  }

  changeStatus() {
    this.BankForm.value.active = !this.BankForm.value.active
  }

}
